import React from 'react'
import { profile3,profile4,profile5,profile6 } from '../../images'
import "./Testimonial.css"
// import Swiper core and required modules
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination } from 'swiper/modules';
// Import Swiper styles
import 'swiper/css';
import 'swiper/css/pagination';

const data = [
  {
    avatar:profile3,
    name:'Relationships',
    review:` Throughout Steins;Gate, Okabe Rintarou forms important connections with Kurisu, Mayuri, Daru, and others. These relationships play a crucial role in his journey, influencing his growth as he navigates the complexities and chaos of time travel.`
  },
  {
    avatar:profile4,
    name:'Background',
    review:` Okabe Rintarou starts as a typical university student in Akihabara who suddenly discovers the secrets of time travel. As he delves into the complexities of worldlines, he becomes entangled in numerous conflicts and builds significant relationships with those around him, navigating the profound challenges of his new reality.`
  },
  {
    avatar:profile5,
    name:'Character Development',
    review:` Throughout the series, Okabe Rintarou undergoes substantial character development as he faces his own flaws and the repercussions of tampering with time. He grows emotionally, gaining a deeper insight into the impact of his decisions and learning to trust those around him.`
  },
  {
    avatar:profile6,
    name:'Role in the Story',
    review:` Okabe Rintarou is the central figure in Steins;Gate. He plays a crucial role in the narrative as he leverages his knowledge of time travel to tackle the numerous challenges and dangers that arise. Through his actions and decisions, he impacts the lives of those around him and affects the course of events in his struggle against the forces seeking to disrupt the flow of time.`
  }

];


const Testimonial = () => {
  return (
    <section id='testimonial'>
      <div className="section__wrapper">
          <div className="section__header">
             <h2 className='primary__title'>Okabe's journey</h2>
             <p className='text__muted description'>
               Okabe Rintarou is the central character in the anime series Steins;Gate. Here’s an overview of his role and significance:
               <br />
               <br />
               Okabe Rintarou's journey in Steins;Gate is filled with both successes and hardships, making him a multifaceted and intriguing protagonist in the series.
             </p>
          </div>
    
          <Swiper className="testimonial__container"
           modules={ [Pagination]}
           spaceBetween={40}
           slidesPerView={1}
           pagination={{ clickable: true }}
           breakpoints={{
            700:{
              slidesPerView:2,
              }
            }
           }
           >
            
            {
              data.map(({avatar,name,review},index) =>{
                return(
            <SwiperSlide key={index} className="testimonial">
              <div className="client__avatar">
                <img src={avatar} alt={review} /> 
              </div>
              
              <h3 className='client__name'>{name}</h3>
                <small className="client__review">
                       {review}
                </small>
            </SwiperSlide>
                )
              })
            }
          </Swiper>
      </div>
    </section>
  )
}

export default Testimonial



/* 

















const data = [
  {
    avatar:AVTR1,
    name:'Samuel Eze',
    review:` Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod 
            tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim
           veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea`
  },
  {
    avatar:AVTR2,
    name:'Gloria Chiwendu',
    review:` Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod 
            tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim
           veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea`
  },
  {
    avatar:AVTR3,
    name:'Emmanuel Joseph',
    review:` Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod 
            tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim
           veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea`
  },
  {
    avatar:AVTR4,
    name:'Peter Stone',
    review:` Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod 
            tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim
           veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea`
  }

];

const Testimonials = () => {
  return (
    <section id="testimonials">
      <h5>Review from clients</h5>
      <h2>Testimonials</h2>

      <Swiper className="container testimonials__container"
       modules={ [Pagination]}
       spaceBetween={40}
       slidesPerView={1}
       pagination={{ clickable: true }}>
        
        {
          data.map(({avatar,name,review,index}) =>{
            return(
        <SwiperSlide key={index} className="testimonial">
          <div className="client__avatar">
            <img src={avatar} alt={review} /> 
          </div>
          
          <h5 className='client__name'>{name}</h5>
            <small className="client__review">
                   {review}
            </small>
        </SwiperSlide>
            )
          })
        }
        
       
    
        
    


      </Swiper>
    </section>
  )
}

export default Testimonials


*/
